import React from "react";
import PostCard from "./common/PostCard";
import PostRelatedCard from "./common/PostRelatedCard";

const searchQuery = (post, term) => {
    if (term === "" || !term) {
        return false;
    }

    let reviews = false;

    post.tags.forEach((tag) => {
        if (tag.slug.includes("-review")) {
            reviews = true;
        }
    });

    if (reviews) {
        return false;
    }

    return (
        (post.title && post.title.toLowerCase().includes(term.toLowerCase())) ||
        (post.custom_excerpt &&
            post.custom_excerpt.toLowerCase().includes(term.toLowerCase())) ||
        (post.html && post.html.toLowerCase().includes(term.toLowerCase()))
    );
};

export const getCount = (posts, term) => {
    let count = 0;
    posts.forEach(({ node }) => {
        if (searchQuery(node, term)) {
            count += 1;
        }
    });
    return count;
};

export const removeHash = (name) => {
    let newName = name;

    if (name.charAt(0) === "#") {
        newName = name.substring(1, name.length);
    }

    if (name.substring(0, 5) === "hash-") {
        newName = name.substring(6, name.length);
    }

    return newName.toLowerCase().replace(" ", "-");
};

const getSearchList = (posts, term) => {
    let allPosts = [];

    posts.forEach((post) => {
        if (searchQuery(post.node, term)) {
            allPosts.push(post);
        }
    });

    return allPosts;
};

const removeAndReplace = (value, term) =>
    Object.keys(value).some(
        (k) => removeHash(value[k].name) === `${removeHash(term)}`
    );

const getPostList = (posts, filter, industry, country, slug) => {
    let allPosts = [];

    posts.forEach(({ node }) => {
        const hasCountry = removeAndReplace(node.tags, country);
        const hasIndustry = removeAndReplace(node.tags, industry);
        const hasFilter = removeAndReplace(node.tags, filter);
        const isSlug = removeAndReplace(node.tags, slug);

        if (isSlug) {
            const data = getPosts(
                country,
                hasCountry,
                industry,
                hasIndustry,
                filter,
                hasFilter,
                node
            );

            if (data) {
                allPosts.push(data);
            }
        }
    });

    return allPosts;
};

const getPosts = (
    country,
    hasCountry,
    industry,
    hasIndustry,
    filter,
    hasFilter,
    node
) => {
    if (
        industry !== "" &&
        hasIndustry &&
        (country === "" || country.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (industry.toLowerCase() === "all" || industry === "") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (industry.toLowerCase() === "all" || industry === "") &&
        (country === "" || country.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (industry.toLowerCase() === "all" || industry === "") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (industry.toLowerCase() === "all" || industry === "") &&
        (country === "" || country.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        industry !== "" &&
        hasIndustry &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        country !== "" &&
        hasCountry &&
        (industry === "" || industry.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (country.toLowerCase() === "all" || country === "") &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (country.toLowerCase() === "all" || country === "") &&
        (industry === "" || industry.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (country.toLowerCase() === "all" || country === "") &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (country.toLowerCase() === "all" || country === "") &&
        (industry === "" || industry.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        country !== "" &&
        hasCountry &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        filter !== "" &&
        hasFilter &&
        (industry === "" || industry.toLowerCase() === "all") &&
        (country === "" || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        (industry === "" || industry.toLowerCase() === "all") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        (country === "" || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        (industry === "" || industry.toLowerCase() === "all") &&
        (country === "" || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        filter !== "" &&
        hasFilter &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        filter !== "" &&
        hasFilter &&
        (country === "" || country.toLowerCase() === "all") &&
        (industry === "" || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        ((industry !== "" && hasIndustry) || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        (country === "" || country.toLowerCase() === "all") &&
        ((industry !== "" && hasIndustry) || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        (industry === "" || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        (country === "" || country.toLowerCase() === "all") &&
        (industry === "" || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        filter !== "" &&
        hasFilter &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        ((industry !== "" && hasIndustry) || industry.toLowerCase() === "all")
    ) {
        return node;
    } else {
        return null;
    }
};

const createPostFeeds = (
    posts,
    term = false,
    postLength = 4,
    search = false,
    filter = "",
    industry = "",
    country = "",
    slug = "",
    maxPosts = 7,
    handleClick = false
) => {

    const postFeed = [];

    let onlyPosts = null;

    if (search) {
        onlyPosts = getSearchList(posts, term);
    } else {
        onlyPosts = getPostList(posts, filter, industry, country, slug);
    }

    if (onlyPosts && onlyPosts.length === 0) {
        return (
            <p>
                Sorry, no posts are available at this time. Please use the
                filters above, or select from the industry dropdown.
            </p>
        );
    }

    if(onlyPosts.length < 27)
        maxPosts = 2;

    let onlyPostLength = Math.ceil(onlyPosts.length / maxPosts);
    let maxLength = onlyPostLength < postLength ? onlyPostLength : postLength;
    
    if (search) {
        for (let i = 0; i < maxLength; i++) {
            postFeed.push(<>
                    {onlyPosts.map((post, id) => {
                        if (id < maxPosts && i === 0) {
                            return (
                                <PostCard
                                    id={id}
                                    key={id}
                                    post={post.node}
                                    maxPosts={maxPosts}
                                    posts = {posts}
                                />
                            );
                        } else if (
                            id >= maxPosts * i &&
                            id < maxPosts * (i + 1) &&
                            i > 0
                        ) {
                            return (
                                <PostCard
                                    id={id}
                                    key={id}
                                    post={post.node}
                                    maxPosts={maxPosts}
                                    posts = {posts}
                                />
                            );
                        }

                        return null;
                    })}
                    </>
            );
        }
    } else {
        for (let i = 0; i < maxLength; i++) {
            postFeed.push(<>
                    {onlyPosts.map((node, id) => {
                        if (id < maxPosts && i === 0) {
                            return (
                                <PostCard
                                    id={id}
                                    key={id}
                                    post={node}
                                    maxPosts={maxPosts}
                                    posts = {posts}
                                />
                            );
                        } else if (
                            id >= maxPosts * i &&
                            id < maxPosts * (i + 1) &&
                            i > 0
                        ) {
                            return (
                                <PostCard
                                    id={id}
                                    key={id}
                                    post={node}
                                    maxPosts={maxPosts}
                                    posts = {posts}
                                />
                            );
                        }

                        return null;
                    })}
                    </>
            );
        }
    }

    return postFeed;
};

export const createRelatedPostFeeds = (posts, post) => {
    let postFeed = [];
    let maxPosts = 3;

    let count = 0;
    postFeed.push(
        <section className="post-related" key={count}>
            <h1 className="post-related-title">
                Wellll if you like that, then check:
            </h1>
            <div className={`post-related-feed`}>
                {posts.map(({ node }, id) => {
                    if (
                        node.primary_author.slug === post.primary_author.slug &&
                        count < maxPosts &&
                        node.id !== post.id
                    ) {
                        count += 1;
                        return <PostRelatedCard key={id} post={node} />;
                    }
                    return null;
                })}
            </div>
        </section>
    );

    return postFeed;
};

export default createPostFeeds;
